import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-alert-messages',
  templateUrl: './alert-messages.component.html',
  styleUrls: ['./alert-messages.component.scss']
})
export class AlertMessagesComponent implements OnInit {
  @Input() type!: 'loading' | 'alert'| 'update' | 'tons'|'alertTons';
  @Input() alertIcon!: string;
  @Input() alertImg!: string;
  @Input() messageLoading!: string;
  @Input() boldMessageLoading!: string;
  @Input() message!: string;
  @Input() boldMessage!: string;
  @Input() extraMessage: boolean = false;
  @Input() weight?: string;
  @Input() volume?: string;
  @Input() loadingStockReal?: string;
  @Input() buttonText?: string;
  @Output() showDetail: EventEmitter<void> = new EventEmitter<void>();
  readonly tooltipText='Solo están considerados lo productos con stock, peso y volumen identificado.';
  constructor(   private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,) {
    this.matIconRegistry.addSvgIcon(
      `icon_alert_black`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/svg/icon-alert_tooltip.svg'
      )
    );
  }

  ngOnInit() { 
  }
 // Este método puedes llamarlo desde el HTML del componente hijo
 emitDetail() {
  this.showDetail.emit();
}
}
